/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphProfitCurveIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Profit Curve',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2.513 2.006A.51.51 0 0 0 2 2.514v1a.5.5 0 0 0 .492.493A28.07 28.07 0 0 1 22.036 12H20v2h3.89a30.937 30.937 0 0 1 7.1 19.512.494.494 0 0 0 .493.49h1a.508.508 0 0 0 .507-.512C32.745 16.791 20.308 2.28 2.513 2.006ZM22 28h2v4h-2z"
    />
    <path d="M22 22h2v4h-2zM22 16h2v4h-2zM14 12h4v2h-4zM8 12h4v2H8zM2 12h4v2H2z" />
  </svg>`;
};
